
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-582f7de6!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RepositorioPSC.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./RepositorioPSC.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-582f7de6!../../node_modules/vue-loader/lib/selector?type=template&index=0!./RepositorioPSC.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/RepositorioPSC.vue
// module id = 86
// module chunks = 0